export const SHOP_THE_LOOK_ASPECT_RATIO = ['3 / 2', null, '8 / 3'];
